import actions from './actions'


export type TActionDefinition = {
  label: string
  action?: string
}

export type THeaderActionsState = {
  mainAction?: TActionDefinition
  subActions?: TActionDefinition[]
}

// const STORED_STATE = (initialState: TBreadcrumbState): TBreadcrumbState => {
//   return initialState
// }

const initialState: THeaderActionsState = {

}

export default function headeractionsReducer(state: THeaderActionsState = initialState, action: any) {
  switch (action.type) {
    case actions.SET_ACTIONS:
      return {
        ...state,
        ...action.payload,
      }
    case actions.SET_STATE:
      return {
        ...state,
        ...action.payload,
      }
    case actions.GET_STATE:
      return state
    default:
      return state
  }
}
